export default __webpack_public_path__ + "static/media/Armbands of the Ascension.8228b049.jpg";